export default __webpack_public_path__ + "static/media/mode-12.9a039d10.svg";